<template>
  <div class="contentArea">
    <AgGrid />
  </div>
</template>

<script>
import AgGrid from "@/views/elements/ag-grid-table/AgGridTable.vue";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      nowSlug: "getNowSlug",
      tabActive: "general/tabActive",
      page: "general/page",
      pointer: "general/pointer"
    })
  },
  components: {
    AgGrid
  },

  async mounted() {
    await this.$store.dispatch(
      "general/getCourseDetail",
      this.$route.params.id
    );
    this.$store.dispatch("general/push_pointer", "video");
  },
  data() {
    return {};
  },
  beforeDestroy() {
    this.$store.dispatch("general/clear_page");
  }
};
</script>

<style lang="scss" scoped></style>
